import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function CanonicalLink() {
  const location = useLocation();

  useEffect(() => {
    // Define the primary production domain
    const primaryDomain = "https://birchwrite.com";

    // Get the current pathname from React Router
    let pathname = location.pathname;

    // Normalize the path by removing trailing slash (unless it's the root path)
    if (pathname.length > 1 && pathname.endsWith("/")) {
      pathname = pathname.slice(0, -1);
    }

    // Construct the full canonical URL
    const canonicalUrl = `${primaryDomain}${pathname}`;

    // Find the existing canonical link element, or create a new one
    let linkElement = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;

    if (linkElement) {
      linkElement.setAttribute("href", canonicalUrl);
    } else {
      linkElement = document.createElement("link");
      linkElement.setAttribute("rel", "canonical");
      linkElement.setAttribute("href", canonicalUrl);
      document.head.appendChild(linkElement);
    }
  }, [location.pathname]);

  return null;
}
